import React from 'react';
import {Box, Typography} from '@mui/material';
import {Controller, Control, FieldErrors} from 'react-hook-form';
import ArrSingleSelectDropdown from '../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {FormValues} from '../schema';
import {t} from 'i18next';

type KV = {key: string; displayValue: string};

const DatDelimitersSection: React.FC<{
  control: Control<FormValues>;
  errors: FieldErrors<FormValues>;
  columnDelimeter: KV[];
  dataDelimeter: KV[];
  textQualifier: KV[];
  disabled?: boolean;
}> = ({
  control,
  errors,
  columnDelimeter,
  dataDelimeter,
  textQualifier,
  disabled = false,
}) => {
  return (
    <Box className="section-block" component="section">
      <Typography
        className="section-title typo-text subhead4_size"
        component="h3"
        id="dat-delimiters-heading"
        tabIndex={0}
        data-testid={`dat-delimiters-section-dat-delimiter-title`}>
        {t('ingestions.Wizard.datDelimiterTitle')}
      </Typography>
      <Box className="row three-cols">
        <Controller
          name="fieldSeparator"
          control={control}
          render={({field}) => (
            <ArrSingleSelectDropdown
              dropdownLabel={t(
                'ingestions.Wizard.datDelimiterSection.fieldSeparator'
              )}
              dropdownItems={columnDelimeter}
              dropdownItemDisplay="displayValue"
              dropdownItemKey="key"
              searchable
              selectedValues={field.value ?? null}
              onSelectionChange={(val) => field.onChange(val)}
              error={!!errors?.fieldSeparator}
              errorText={
                (errors?.fieldSeparator?.message as string) ?? undefined
              }
              disabled={disabled}
              dataTestId="asd-field-separator-dropdown"
              selectRestProps={{
                'aria-label': t(
                  'ingestions.Wizard.ariaLabels.datDelimitersSection.fieldSeparatorDropdown'
                ),
                'aria-required': true,
                'aria-invalid': !!errors?.fieldSeparator,
                'aria-describedby': errors?.fieldSeparator
                  ? 'field-separator-error'
                  : undefined,
              }}
              tabIndex={-1}
              inputLabelProps={{
                'aria-label': t(
                  'ingestions.Wizard.datDelimiterSection.fieldSeparator'
                ).replace('*', ', required'),
              }}
            />
          )}
        />

        <Controller
          name="textQualifier"
          control={control}
          render={({field}) => (
            <ArrSingleSelectDropdown
              dropdownLabel={t(
                'ingestions.Wizard.datDelimiterSection.textQualifier'
              )}
              dropdownItems={dataDelimeter}
              dropdownItemDisplay="displayValue"
              dropdownItemKey="key"
              searchable
              selectedValues={field.value ?? null}
              onSelectionChange={(val) => field.onChange(val)}
              error={!!errors?.textQualifier}
              errorText={
                (errors?.textQualifier?.message as string) ?? undefined
              }
              disabled={disabled}
              dataTestId="asd-text-qualifier-dropdown"
              selectRestProps={{
                'aria-label': t(
                  'ingestions.Wizard.ariaLabels.datDelimitersSection.textQualifierDropdown'
                ),
                'aria-required': true,
                'aria-invalid': !!errors?.textQualifier,
                'aria-describedby': errors?.textQualifier
                  ? 'text-qualifier-error'
                  : undefined,
              }}
              tabIndex={-1}
              inputLabelProps={{
                'aria-label': t(
                  'ingestions.Wizard.datDelimiterSection.textQualifier'
                ).replace('*', ', required'),
              }}
            />
          )}
        />

        <Controller
          name="multiValue"
          control={control}
          render={({field}) => (
            <ArrSingleSelectDropdown
              dropdownLabel={t(
                'ingestions.Wizard.datDelimiterSection.multiValue'
              )}
              dropdownItems={textQualifier}
              dropdownItemDisplay="displayValue"
              dropdownItemKey="key"
              searchable
              selectedValues={field.value ?? null}
              onSelectionChange={(val) => field.onChange(val)}
              error={!!errors?.multiValue}
              errorText={(errors?.multiValue?.message as string) ?? undefined}
              disabled={disabled}
              dataTestId="asd-multi-value-dropdown"
              selectRestProps={{
                'aria-label': t(
                  'ingestions.Wizard.ariaLabels.datDelimitersSection.multiValueDropdown'
                ),
                'aria-required': true,
                'aria-invalid': !!errors?.multiValue,
                'aria-describedby': errors?.multiValue
                  ? 'multi-value-error'
                  : undefined,
              }}
              inputLabelProps={{
                'aria-label': t(
                  'ingestions.Wizard.datDelimiterSection.multiValue'
                ).replace('*', ', required'),
              }}
              tabIndex={-1}
            />
          )}
        />
      </Box>
    </Box>
  );
};

export default DatDelimitersSection;
